export enum Images {
  ArborDayLogoWide = "https://embedded-links.us-1.lytho.us/links/3fed7521-acbd-406b-bb4a-b30a65a36af4",
}
